export default () => {

  const navigationButtons = document.querySelectorAll('.patronage-archive-navigation button'),
        cards = document.querySelectorAll('.patronage-archive .patronage-card');

  if (!navigationButtons || !cards) {
    return;
  }

  navigationButtons?.forEach(item =>{
    item.addEventListener('click', e =>{
      navigationButtons?.forEach(item =>{
        item.classList.add('collapsed');
      })
      item.classList.remove('collapsed');
      cards?.forEach(card =>{
        card.classList.remove('show');
      })
    })
  })
}